export enum FilterTypes {
  Location = 'Location',
  projectType = 'Project type',
  Standard = 'Standard',
  Status = 'Status',
  Methodology = 'Methodology',
}

export const filterKeyToQueryParamMap: Record<string, string> = {
  [FilterTypes.Location]: 'country',
  [FilterTypes.projectType]: 'type',
  [FilterTypes.Methodology]: 'methodology',
  [FilterTypes.Standard]: 'standard',
};
